/**
 * Auth components abstraction layer
 * Updated for Better Auth (migrated from Better Auth)
 */

import { useAuthState } from './hooks.js';

/**
 * Auth provider wrapper - wraps the entire app
 * With Better Auth, this is simplified since the client handles state internally
 * @param {{ children: React.ReactNode }} props
 */
export function AuthProvider({ children }) {
  // Better Auth doesn't require a provider component like Better Auth
  // The authClient handles state management internally
  // This wrapper is kept for API compatibility
  return children;
}

/**
 * Renders children only when user is signed in
 * @param {{ children: React.ReactNode }} props
 */
export function AuthSignedIn({ children }) {
  const { isSignedIn, isLoaded } = useAuthState();

  // Don't render while loading
  if (!isLoaded) {
    return null;
  }

  // Only render if user is signed in
  if (isSignedIn) {
    return children;
  }

  return null;
}

/**
 * Renders children only when user is signed out
 * @param {{ children: React.ReactNode }} props
 */
export function AuthSignedOut({ children }) {
  const { isSignedIn, isLoaded } = useAuthState();

  // Don't render while loading
  if (!isLoaded) {
    return null;
  }

  // Only render if user is NOT signed in
  if (!isSignedIn) {
    return children;
  }

  return null;
}

/**
 * Shows a loading state while auth is being determined
 * @param {{ children: React.ReactNode }} props
 */
export function AuthLoading({ children }) {
  const { isLoaded } = useAuthState();

  if (!isLoaded) {
    return children;
  }

  return null;
}
